import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BuildWatcher } from '@unimarket/shared';
import { filter } from 'rxjs';

/** Once a newer build is out, the next click loads the page from the server instead, so nobody is reloaded mid-page. */
@Injectable({ providedIn: 'root' })
export class AppService {

  private document = inject(DOCUMENT);
  private router = inject(Router);
  private builds = inject(BuildWatcher);
  private stale = false;

  start(): void {
    this.builds.watch('/index.csr.html', () => this.stale = true);
    this.router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart && this.stale))
      .subscribe(event => {
        const location = this.document.defaultView!.location;
        // Back and forward have already changed the address; a click has not yet
        if (event.navigationTrigger === 'popstate') {
          location.reload();
        } else {
          location.assign(event.url);
        }
      });
  }

}
